import React from 'react'
import * as styles from './_AdviserProfileSubmitForApproval.scss'
import SubmitButtonForApproval from '../../../common/forms/SubmitButtonForApproval'
import SubmitSpinner from '../../../common/Spinners/SubmitSpinner'
import SuccessCheckMessage from '../../../common/SuccessCheckMessage'
import { actions } from './adviserProfileSubmitForApprovalActions'
import { Alert, FormCheck, Modal, Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdviserTermsAndConditions from '../AdviserTermsAndConditions/AdviserTermsAndConditions'
import close from './close.svg'
import PropTypes from 'prop-types';

class AdviserProfileSubmitForApproval extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    submitForApproval: PropTypes.func.isRequired,
    edited: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool,
    submitted: PropTypes.bool.isRequired,
    readyForApproval: PropTypes.bool.isRequired,
    invalidArray: PropTypes.array.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.node, 
      PropTypes.arrayOf(PropTypes.node)
    ]),
    containerIsValid: PropTypes.bool.isRequired,
    hasPendingProfile: PropTypes.bool
  };

  constructor () {
    super()
    this.state = {
      termsAccepted: false,
      modal: false
    }
    this.hideModal = this.hideModal.bind(this)
    this.showModal = this.showModal.bind(this)
  }

  hideModal (event) {
    this.setState({ modal: false })
    if (event) {
      event.preventDefault()
    }
  }

  showModal (event) {
    this.setState({ modal: true })
  }

  render () {
    const adviserId = this.props.profile.adviserId
    const message = 'Your profile has been submitted for approval.'
    const submitting = this.props.submitting
    const edited = this.props.edited
    const termsAccepted = this.state.termsAccepted
    return (
      <div>
        {<Row>
          <Col sm={12} md={8} lg={8} className="d-none d-sm-block">
            <div className={styles['terms-and-conditions']}>
              <form>
                <FormCheck
                  key={99}
                  type="checkbox"
                  className={styles['inline-block'] || ''}
                  checked={Boolean(termsAccepted || this.props.hasPendingProfile)}
                  value={termsAccepted}
                  disabled={this.props.hasPendingProfile}
                  onChange={() => {
                    this.setState({ termsAccepted: !termsAccepted })
                  }}
                  label=" "
                />

                <span>I accept the&nbsp;
                <a style={{ cursor: 'pointer' }}
                  onClick={this.showModal}>Terms and Conditions</a> of Allan Gray and Find an IFA
            </span>
              </form>
            </div>
            <div>
              {!this.props.readyForApproval && <Alert variant='warning' >
                <p>Your profile does not have all the mandatory fields filled in yet</p>
                <p>Here is a list of everything you need before you can submit your profile for approval</p>
                <ul>
                  {this.props.invalidArray.map((invalidItem, index) => {
                    return <li key={index}>{invalidItem}</li>
                  })}
                </ul>
              </Alert>}
              <SubmitButtonForApproval
                buttonText={'Submit for approval'}
                isValid={this.props.readyForApproval && this.props.containerIsValid && (!this.props.hasPendingProfile)}
                isSubmitting={submitting}
                onClick={() => this.props.submitForApproval(adviserId)}
                isTermsAccepted={termsAccepted}
                isSubmitted={this.props.submitted}
              />
              {(this.props.isSubmitting || submitting) && <SubmitSpinner />}
              <div className={styles['approval-message']}>
                {this.props.submitted && !edited && <SuccessCheckMessage message={message} />}
              </div>
              {this.props.children}
            </div>
            <Modal show={this.state.modal} className={styles['modal']}>
              <Modal.Body>
                <div className={styles['close-button-div']}>
                  <a onClick={(event) => this.hideModal(event)} href='#' className={styles['close-anchor']}>
                    <img src={close} height={25} width={25} />
                  </a>
                </div>
                <AdviserTermsAndConditions className={styles['terms-and-conditions']} />
              </Modal.Body>
            </Modal>
          </Col>
        </Row>}
      </div>
    )
  }
}

const mapStateToProps = ({ adviserProfileEditorContainer }) => {
  return {
    edited: adviserProfileEditorContainer.edited,
    submitting: adviserProfileEditorContainer.submissionForApproval.submitting,
    submitted: adviserProfileEditorContainer.submissionForApproval.submitted,
    readyForApproval: adviserProfileEditorContainer.readyForApproval,
    invalidArray: adviserProfileEditorContainer.invalidArray,
    // Was used in isValid/the checkbox but never mapped, so the "can't re-submit while
    // pending" guard never actually fired. Wire it up.
    hasPendingProfile: adviserProfileEditorContainer.hasPendingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    submitForApproval: actions.submit.submitForApproval
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfileSubmitForApproval))
